import { useContext } from "react";
import TenantProviderContext from "../context/TenantProvider";

const useTenant = () => {
    return useContext(TenantProviderContext);
}

export default useTenant;